<template>
  <div class="pageFull megaMenu" :style="pageStyle">
    <div class="menuBox" :style="navStyle">
      <button type="button" class="btnClose" @click.stop="setMegaMenu"></button>
      <div class="menuListBox">
        <div class="menuList">
          <MegaMenuTree
            v-for="category in categoryList"
            :key="category.categoryId"
            :category="category"
            :locale="locale"
            :lang="lang"
            :depth="1"
            :defaultFontColor="defaultFontColor" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MegaMenuTree from './MegaMenuTree'

export default {
  name: 'CollectionMegaMenu',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId'
  ],
  components: {
    MegaMenuTree
  },
  computed: {
    getPageSetting () {
      return this.$store.getters['collection/getCollectionSetting']
    },
    defaultFontColor () {
      return this.getPageSetting && this.getPageSetting.fontColor
    },
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    getNavSetting () {
      return this.$store.getters['collection/getCollectionNavSetting']
    },
    navStyle () {
      const setting = this.getNavSetting
      const category = setting && setting.category
      const fontFamily = (category && category.fontFamily && `${category.fontFamily.default}, ${category.fontFamily.default2}, ${category.fontFamily.default3}`) || ''
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return {
        color: category && category.text && category.text.color,
        letterSpacing: `${spacingToLts(category && category.text && category.text.spacing)}em`,
        fontSize: `${category && category.text && category.text.size}px`,
        fontFamily: fontFamily
      }
    },
    isMyCollection () {
      return this.$route.name === 'myCollection'
    },
    pageFrame () {
      const frame = this.$store.getters['collection/getPageFrame']
      return frame ? `${frame}px` : ''
    },
    pageStyle () {
      const isMyCollection = this.isMyCollection
      const setting = this.getPageSetting
      const category = this.getNavSetting && this.getNavSetting.category
      const myCollectionSetting = this.getMyCollectionSetting
      const frame = this.pageFrame
      function spacingToLts (spacing) {
        const numeric = parseFloat(spacing)
        if (isNaN(numeric)) return null // 유효하지 않은 입력 처리
        return (numeric / 1000).toFixed(2)
      }
      return {
        top: `${this.top}px`,
        letterSpacing: `${spacingToLts(category && category.text && category.text.spacing)}em`,
        backgroundColor: isMyCollection ? myCollectionSetting && myCollectionSetting.backgroundColor : setting && setting.backgroundColor,
        ...frame && {
          paddingLeft: frame,
          paddingRight: frame,
          paddingBottom: frame
        },
      }
    },
    categoryList () {
      return this.$store.getters['collection/getCategoryListAll']
    }
  },
  destroyed () {
    const content = document.querySelector('.collectionContent')
    if (content) {
      content.style.overflow = ''
    }
  },
  created () {
    const nav = document.querySelector('.collectionNavTop')
    if (nav) {
      const content = document.querySelector('.collectionContent')
      this.top = nav.getBoundingClientRect().height
      content.style.overflow = 'hidden'
    }
  },
  data () {
    return {
      top: 100
    }
  },
  methods: {
    setMegaMenu () {
      this.$store.commit('collection/setMegaMenu', false)
    }
  }
}
</script>